<div *ngIf="!isWizard">
  <div class="sub-header">{{'onboarding.select_location' | translate}}</div>

  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.select_location' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_shop_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-home"></i></span>
        <p-dropdown [options]="locations" [(ngModel)]="config.LocationID" (onChange)="updateConfig()"
                    placeholder="{{'onboarding.select_shop' | translate}}">
        </p-dropdown>
      </div>
    </div>
    <div class="col-md-4 label">
      Square Payments:
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <div class="p-inputgroup pull-right">
          <p-inputSwitch [(ngModel)]="config.UseSquarePayments" (ngModelChange)="updateConfig()"></p-inputSwitch>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="technicians && technicians.length > 0 && isWorkshop">
    <div class="sub-header margin-top-16">
      {{ "bikeshop.shop_profile.pos-integration.technichan_linking" | translate }}
    </div>
    <div><small>{{ "bikeshop.shop_profile.pos-integration.technichan_linking_info" | translate }}</small></div>
    <div *ngFor="let technician of technicians" class="row margin-top-8">
      <div class="col-md-4 label">
        {{technician.Firstname}} {{technician.Surname}}
      </div>
      <div class="col-md-8">
        <p-dropdown [options]="users" [(ngModel)]="technician.POSEmployeeID" [showClear]="true" (onChange)="updateTechnicians()"
                    placeholder="{{ 'bikeshop.shop_profile.pos-integration.link_technician_to_pos_employee' | translate }}">
        </p-dropdown>
      </div>
    </div>
  </div>


  <div *ngIf="paymentDevices && paymentDevices.length > 0">
    <div class="sub-header margin-top-16">
      {{ "bikeshop.shop_profile.pos-integration.payment_device_linking" | translate }}
    </div>
    <div><small>{{ "bikeshop.shop_profile.pos-integration.payment_device_linking_info" | translate }}</small></div>
    <div class="row margin-top-8">
      <div class="col-md-4 label">
        {{ "bikeshop.shop_profile.pos-integration.payment_device" | translate }}:
      </div>
      <div class="col-md-8">
        <p-dropdown [options]="paymentDevices" [(ngModel)]="config.DeviceID" [showClear]="true" (onChange)="updatePaymentDevices()"
                    placeholder="{{ 'bikeshop.shop_profile.pos-integration.payment_device' | translate }}">
        </p-dropdown>
      </div>
    </div>
  </div>


</div>

<!--Bit of a stuff up because of the dark UI in the wizard and light wizard in the portal, this is a shared compnent :(-->
<div *ngIf="isWizard">
  <div class="row margin-top-32 help-row">
    <div class="col-md-12">
      <div class="p-float-label">
        <p-dropdown [options]="locations" [(ngModel)]="config.LocationID"
                    placeholder="{{'onboarding.select_shop' | translate}}">
        </p-dropdown>
        <label>{{'onboarding.select_location' | translate}}</label>
      </div>
    </div>
    <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_shop_info' | translate}}"></span>
  </div>

  <div class="row margin-top-32">
    <div class="col-md-12">
      <button type="submit" class="iso-round-button" style="float: right;"
              (click)="updateConfig()"
              [disabled]="busy || !config.LocationID">{{ busy ? ('onboarding.button.please_wait' | translate) : (config.LocationID) ? ('onboarding.button.update_config' | translate) : ('onboarding.button.set_config' | translate)}}</button>
    </div>
  </div>
  <div class="row margin-top-32">
    <div class="col-md-12">
      <button pButton (click)="skipToHubtiger()" class="p-button alternate full-width"
              label="{{ 'onboarding.button.skip_to_hubtiger' | translate}}"></button>
      <!--          todo (dcorbett) - removed *ngIf="!configurationSaved"-->
    </div>
  </div>
</div>


